module.exports = __webpack_public_path__ + "img/credit-card-refresh.be746c51.svg";